














































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import { getModule } from 'vuex-module-decorators'
import { db } from '../firebase/init'
import MainMixin from '../mixins/MainMixin'
import User from '../store/modules/user'
import TaskStore from '../store/modules/tasks'
import SingleTask from '../components/tasks/SingleTask.vue'
import { RequestOffType } from '../types'
import TaskWrapper from '../components/tasks/TaskWrapper.vue'
import CardList from '../components/layout/CardList.vue'

const requestsOff = collection<RequestOffType>('requestsOff')

@Component({
  components: {
    CardList,
    SingleTask,
    TaskWrapper,
  },
})

export default class Tasks extends Mixins(MainMixin) {
  tabs = [{ title: "Today's Tasks", value: 'today' }, { title: 'Upcoming', value: 'upcoming' }]

  taskFilter = (task:any) => task.completed === null

  selectedTab = 'due'

  get filteredTasks() {
    return this.$store.getters.employeeTasks.filter(this.taskFilter)
  }

  requestType = 'View Upcoming'

  Tasks = getModule(TaskStore)

  requestDates = ['', '']

  get allTasks() {
    console.log('tt is: ', this.Tasks)
    if (!this.Tasks || !this.Tasks.getters) return []
    return this.Tasks.employeeTasks
  }

  showTaskDetails = [false, true, false, false, false]

  makeShow(x:boolean, y:number) {
    this.showTaskDetails.splice(y, 1, x)
    console.log('event is: ', x)
    console.log('y is: ', y)
    this.hideAll(y)
  }

  hideAll(id:number) {
    console.log('asdf ', this.showTaskDetails)
    this.showTaskDetails.forEach((task, index) => {
      if (index !== id) {
        this.showTaskDetails.splice(index, 1, false)
      }
    })
    console.log('asdf ', this.showTaskDetails)
  }

  loading = false
}
